module.exports = __webpack_public_path__ + "img/hp-awp-blue.a03e83ce.png";